var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Nvabar'),_c('banner'),_c('about'),_c('news'),_c('friends'),_c('footbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }